import {LinkGroup} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';
import {CorpusGroup} from './corpus.group';
import {MoreGroup} from './more.group';
import {OtherToolsGroup} from './other-tools.group';

export const ExploreGroup = (context: NavigationContext): LinkGroup  => ({
    type: 'linkGroup',
    label: 'navigation.explore_group',
    links: [
        CorpusGroup(context),
        OtherToolsGroup(context),
        MoreGroup(context)
    ]
})